export function getModel(modelDescription) {
  return Object.keys(modelDescription).reduce((template, property, index, array) => {
    const valueToAdd = modelDescription[property].value || modelDescription[property];
    if (index + 1 === array.length) {
      return `${template}${valueToAdd}`;
    }
    return `${template}${valueToAdd}-`;
  }, '');
}
